(function($) {

	'use strict';

	var init = function() {
        initAnimations()
	};

	var initAnimations = function(){
        var animations = $('.animation');
        $.each(animations, function( index, value ) {
            var offset = '80%';
            $(value).waypoint(function(direction) {
                $(this.element).addClass('animate');
            }, {
                offset: offset
            });
        });
    }

	$(document).ready(function(){
        init();
	});

})(jQuery);
